import TextField, { TextFieldProps } from '@mui/material/TextField'
import { capitalCase } from 'change-case'
import { SyntheticEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// export interface RHFTextFieldProps {
//   id?: string
//   name: string
//   onChangeCallback?: (arg0: SyntheticEvent) => void
//   transform?: {
//     input?: (value: any) => any
//     output?: (e: SyntheticEvent) => any
//   }
// }
//
// export function RHFTextField({ id, name, onChangeCallback, label, ...other }: RHFTextFieldProps & TextFieldProps) {
//   const { control } = useFormContext()
//
//   if (!label) {
//     label = sentenceCase(name || '')
//   }
//
//   const transform = {
//     // This is displayed on the UI
//     input: value => {
//       return other?.transform?.input?.(value) ?? value
//     }, // This is the stored backend value
//     output: e => other?.transform?.output?.(e) ?? e.target.value
//   }
//
//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field: { onChange, value, ref, ...field }, fieldState: { error } }) => (
//         <TextField
//           {...field}
//           {...other}
//           inputRef={ref}
//           id={id ?? name}
//           // value={value === null ? '' : value}
//           value={transform.input(value)}
//           label={((label as string) ?? name ?? '') as string}
//           fullWidth
//           InputProps={{ ...other?.InputProps, type: other?.type ?? 'text' }}
//           error={!!error}
//           helperText={error?.message}
//           size={other.size ?? 'small'}
//           onChange={e => {
//             onChange(e)
//             onChangeCallback?.(e)
//             onChange(transform.output(e))
//           }}
//         />
//       )}
//     />
//   )
// }

// ----------------------------------------------------------------------------------------------------------------------------- //

type Props = TextFieldProps & {
  name: string
  onChangeCallback?: (arg0: SyntheticEvent) => void
  transform?: {
    input?: (value: any) => any
    output?: (e: SyntheticEvent) => any
  }
}

export function RHFTextField({ name, helperText, type, onChangeCallback, ...other }: Props) {
  const { control } = useFormContext()

  const transform = {
    input: value => {
      return other?.transform?.input?.(value) ?? value // This is displayed on the UI
    },
    output: e => {
      return other?.transform?.output?.(e) ?? e.target.value // This is the stored backend value
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={transform.input(field?.value)}
          onChange={e => {
            field?.onChange(transform.output(e))
            onChangeCallback?.(e)
          }}
          error={!!error}
          helperText={error?.message ?? helperText}
          inputProps={{
            autoComplete: 'off'
          }}
          {...other}
          size={other?.size ?? 'small'}
          label={other?.label ?? capitalCase(name)}
        />
      )}
    />
  )
}

// ----------------------------------------------------------------------------------------------------------------------------- //

// export function RHFTextFieldNoContext({ id, name, onChangeCallback, label, control, ...other }: RHFTextFieldProps & TextFieldProps & { control: Control }) {
//   if (!label) {
//     label = sentenceCase(name || '')
//   }
//
//   const transform = {
//     // This is displayed on the UI
//     input: value => {
//       return other?.transform?.input?.(value) ?? value
//     }, // This is the stored backend value
//     output: e => other?.transform?.output?.(e) ?? e.target.value
//   }
//
//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field: { onChange, value, ref, ...field }, fieldState: { error } }) => (
//         <TextField
//           {...field}
//           {...other}
//           inputRef={ref}
//           id={id ?? name}
//           // value={value === null ? '' : value}
//           value={transform.input(value)}
//           label={((label as string) ?? name ?? '') as string}
//           fullWidth
//           InputProps={{ ...other?.InputProps, type: other?.type ?? 'text' }}
//           error={!!error}
//           helperText={error?.message}
//           size={other?.size}
//           onChange={e => {
//             onChange(e)
//             onChangeCallback?.(e)
//             onChange(transform.output(e))
//           }}
//         />
//       )}
//     />
//   )
// }
